import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import parse from 'html-react-parser';
import Carousel from "react-multi-carousel";
import ImageGallery from "../../components/common/ImageGallery";
import ProgramAccordions from "../../components/ProgramAccordions";

const images = [
  '/images/gallery/france/snap1.jpg',
  '/images/gallery/france/snap2.jpg',
  '/images/gallery/france/snap3.jpg',
  '/images/gallery/france/snap4.jpg',
  '/images/gallery/france/snap5.jpg',
  '/images/gallery/france/snap6.jpg',
  '/images/gallery/france/snap7.jpg', 
  '/images/gallery/france/snap8.jpg',
  '/images/gallery/france/snap10.jpg',
  '/images/gallery/france/snap11.jpg',
  '/images/gallery/france/snap12.jpg',
  '/images/gallery/france/snap13.jpg',
  '/images/gallery/france/snap14.jpg',
  '/images/gallery/france/snap15.jpg',
  '/images/gallery/france/snap16.jpg',
  '/images/gallery/france/snap17.jpg',
  '/images/gallery/france/snap18.jpg',
  '/images/gallery/france/snap19.jpg',
  '/images/gallery/france/snap20.jpg',
  '/images/gallery/france/snap21.jpg',
  '/images/gallery/france/snap22.jpg',
  '/images/gallery/france/snap23.jpg',
  '/images/gallery/france/snap24.jpg',
  '/images/gallery/france/snap25.jpg',
  '/images/gallery/france/snap26.jpg',
  
]
const tabData = [
    {
        id:1,
        title:'THE FRENCH EXPERIENCE',
        desc:"<p>Welcome to Destiny Calling's France Program, your gateway to a transformative journey in the heart of culinary excellence. Our program offers more than just professional growth; it's a profound personal experience.</p><p>When you become a part of Destiny Calling's France Program, you embark on a journey that not only shapes your career but also your individuality. France, renowned for its gastronomic heritage and thriving tourism industry, offers unparalleled opportunities for Hotel Management and Culinary students, and we're here to make sure you get the most out of this incredible adventure.</p><p>As an accepted candidate in our program, you receive exclusive benefits designed to maximize your experience. We understand that language is key to adapting a new culture and to a new environment, so we provide you with French language coaching videos and conduct weekly live sessions with our DELF/DALF certified trainers. These sessions are more than just language lessons; they are your key to understanding the French culture and immersing yourself in it.</p><p>Our 11 years of experience in connecting students with opportunities in France ensures that you have access to the best quality hotels and establishments. We're committed to providing dedicated visa assistance, making the often complicated French visa process hassle-free for you.</p><p>But what sets Destiny Calling apart is our belief that an internship with us not only equips you with skills and knowledge but also enhances your employability. We have insights into what each country expects from an intern, and this knowledge makes our students stand out.</p><p>Here's a remarkable statistic: 50% of our students receive work permit offers from the properties they intern with after completing their internships.</p><p>When you apply, each candidate undergoes a careful review by our top-notch Enrollment Team based on numerous phone consultations and a video interview conducted before onboarding of a student. If accepted we start working with you to find the internship that best matches your background and future goals.</p><p>The French Experience with Destiny Calling isn't just about working in a foreign country; it's about personal and professional growth. It's about stepping out of your comfort zone and embracing a new culture. It's about becoming more than you thought you could be.</p><p>Join us in France, and let's explore the epitome of culinary excellence together.</p>"
    },
    {
        id:2,
        title:'GUARANTEED INTERNSHIP PLACEMENT',
        desc:"<p>At Destiny Calling, our promise is simple yet powerful: a guaranteed internship placement. When you choose to register with us and complete all the necessary documentation, you're not just taking a step towards an adventure in France; you're securing a valuable professional experience that will shape your future.</p><p>We understand how critical it is for aspiring professionals to gain real-world experience, and that's why we make it our mission to ensure your success. From the moment you start your journey with us, our dedicated team works tirelessly to match you with the most suitable internship opportunities available in France.</p><p>Our commitment to your success goes beyond words; it's a relentless pursuit of excellence. Rest assured that once you've met our registration requirements, we won't stop until we've secured an internship placement that aligns with your aspirations and sets you on the path to professional growth</p><p>At Destiny Calling, your success is not just a priority; it's our purpose. We are here to guide you, support you, and ensure that your internship in France becomes an enriching experience that propels you toward a successful future. Let's embark on this journey together, with the assurance of a guaranteed internship placement as your companion.</p>"
    },
    {
        id:3,
        title:'FLUENTZEA - OUR FRENCH LANGUAGE LEARNING COURSE',
        desc:"<p>We understand the unique challenges that students face when interning in France. The ability to converse, understand, and immerse yourself in the French culture is vital for a truly enriching experience. That's why we introduce Fluentzea, a comprehensive French language learning course tailored to your specific needs.</p><p>Fluentzea is the epitome of fluency, designed to equip you with the linguistic skills required for seamless communication and adaptation to the French culture. Our specialized language training program is structured to enhance your proficiency in a way that maximizes the limited time you have before your internship journey begins.</p><p>Over the years, we've recognized that language can be a significant hurdle for internationals. Mastering a language takes time, and we understand that your time before departure is limited. Therefore, our courses focus on practical aspects, emphasizing oral communication skills, as these are the most essential for a successful internship</p><p>Fluentzea offers you pre-recorded video sessions and weekly live online sessions with our certified trainers, ensuring that you gain the confidence and skills needed to converse effectively and make the most of your internship experience in France. With Fluentzea, you're not just learning a language; you're unlocking a world of linguistic confidence that will shape your journey in France and set you on a path to personal and professional growth</p><p>Preparation for your journey starts here. With Fluentzea as your guide, you'll be ready to immerse yourself fully in the French culture, communicate effortlessly, and make the most of your internship in this beautiful country. Begin your linguistic adventure today and discover a world of possibilities with Fluentzea.</p>"
    },
    {
        id:4,
        title:'TRAVEL SUPPORT (Documentation & Translation)',
        desc:"<p>Destiny Calling provides comprehensive travel support to ensure a smooth and hassle-free experience for students. Here's how we assist with travel arrangements:</p><ul><li><strong>Complete French Documentation:</strong> We help students with all necessary documentation procedures involving any certified translation that may be needed, ensuring they have everything in order for their travel and stay in France.</li><li><strong>Flight Bookings:</strong> On request, our logistics partner offers guidance and assistance in booking flights to France, ensuring students find the most convenient and cost-effective options. Students are free to book their flights directly, as per their convenience and wish. However, our team would always be happy to help clear any doubts.</li><li><strong>Visa Support:</strong> Our visa team provides complete visa assistance, guiding students through the application process, securing an appointment, and offering support in arranging the required documents. (Note: The visa embassy fees are to be borne by the student, however, the documentation, application, appointment booking, guidance, review, and the mock training are taken care of by us.)</li><li><strong>Route Map for Arrival:</strong> Destiny Calling provides a detailed route map for students'arrival, offering guidance on how to commute from the airport to their accommodation, etc..</li><li><strong>Emergency Assistance: </strong>We provide students with a list of emergency contact numbers, ensuring they have a reliable point of contact in case of any unforeseen situations during their travel.</li></ul><br/><p>With Destiny Calling's travel support, students can embark on their journey to France with confidence, knowing that their travel arrangements are well taken care of.</p>"
    },
    {
        id:5,
        title:'MENTOR AT EVERY STEP (Induction, Tips & Much More...)',
        desc:"<p>At Destiny Calling, we prioritize mentoring and provide support at every step of the journey to ensure students' success and well-being. Here's how we mentor our students:</p><ul><li><strong>Personalized Guidance: </strong> We offer personalized guidance to students, understanding their individual goals, aspirations, and challenges, and providing tailored advice and support.</li><li><strong>Pre-Departure Mentoring:</strong> Before students embark on their journey, we conduct pre-departure mentoring sessions, equipping them with essential information, tips, and guidance to navigate their new environment effectively.</li><li><strong>Emotional Support: </strong>We understand the emotional challenges of studying abroad. Our mentors are always available to lend a compassionate ear, provide emotional support, and address any concerns or homesickness that students may experience, at any hour of the day. As explained previously, our students are our mini-selves, not clients.</li><li><strong>Ongoing Support: </strong> Throughout the students' journey, our mentors provide ongoing support, conducting regular check-ins, and being readily available to address any queries, concerns, or challenges that may arise.</li><li><strong>Parental Connection: </strong>We believe in establishing a strong connection with parents to keep them informed and involved in their child's study abroad experience. We regularly communicate with parents, providing updates on their child's progress, addressing any concerns, and ensuring a collaborative approach towards their child's success and well-being.</li></ul><br/><p>At Destiny Calling, we are committed to being more than just a program provider. We strive to be mentors and partners, guiding and supporting our students at every step</p>"
    },
    {
        id:6,
        title:'HOUSING AND MEAL SUPPORT',
        desc:"<p>At Destiny Calling, we empathize with the challenges students face when it comes to securing suitable accommodations and ensuring their meals during their internship in France. We recognize that the comfort and quality of your living situation can significantly impact your overall experience.</p><p>In our unwavering commitment to your well-being, we have thoughtfully selected partner hotels that offer accommodations along with duty meals. However, it's crucial to set realistic expectations regarding the accommodations. These lodgings would guarantee minimal amenities and may thus at times, require adjustments. Nevertheless, we emphasize that managing your expectations is the key to a positive experience.</p> <p>Setting a baseline of expectation not only helps prevent disappointment but also ensures that any improvements in your living situation become pleasant surprises. At Destiny Calling, we guarantee that you will receive accommodations that are on par with those provided to other interns at the hotel. Your comfort and satisfaction are our top priorities.</p> <p>When it comes to meals, it's important to remember that the cuisine will be prepared following traditional French recipes. The flavors and ingredients may be quite distinct from what you're accustomed to. While you are certainly free to prepare your meals and explore alternative dining options, we strongly encourage you to fully embrace the cultural experience.</p> <p>Immerse yourself in the vibrant tapestry of French culture, and allow your taste buds to explore the unique flavors of French cuisine. This culinary adventure can add depth and richness to your overall experience during your internship in France. Our aim is not only to provide you with an internship but to offer you a transformative journey, and thatincludes exploring the tastes and textures of a different culture.</p>"
    },
    {
        id:7,
        title:'HEALTH & DEVELOPMENT PROGRAM (Optional)',
        desc:"<p>Destiny Calling is incredibly excited to announce our collaboration with FitInsideOut, a program designed to equip our students with valuable tools for overcoming lifestyle challenges during their internship in France. We understand the unique difficulties that can arise when navigating life abroad, and we are committed to ensuring that our students are well-prepared, not just professionally, but also physically and mentally. The significance of maintaining good health cannot be overstated. You are in France not just to experience the culinary excellence and hospitality industry but also to work diligently, learn effectively, and grow personally and professionally. Being in your best health is paramount, as it directly influences your ability to perform at your peak. However, we acknowledge that this can be a challenging feat, especially in a new environment with unfamiliar food and lifestyle choices.</p><p>Drawing from our years of experience and the valuable feedback from our students, we have partnered with FitInsideOut to address this issue comprehensively. FitInsideOut offers a holistic approach to health and well-being, focusing on physical fitness and mental strength, both of which are integral to your success during your internship in France.</p><p>By choosing to participate in the FitInsideOut program, you will gain access to guidance and resources that will help you adapt to your new surroundings more easily. Maintaining a balanced and healthy diet is a key component of this program, ensuring that you have the energy and vitality needed to excel in both your personal and professional life.</p><p>At Destiny Calling, we believe that being in your best health is not just a personal achievement but a critical factor in your overall internship experience. With FitInsideOut, we aim to support our students in achieving peak physical performance and robust mental well-being, setting them up for success throughout their transformative journey in France. While participation in FitInsideOut is optional, we  advantage of this valuable resource to make the most of your internship experience. Your well-being is our priority, and we are here to support you every step of the way.</p>"
    },
    {
        id:8,
        title:'COUNSELING & THERAPY SESSIONS (Optional)',
        desc:"<p>At Destiny Calling, we wholeheartedly prioritize the emotional well-being of our students and their families throughout their transformative journey abroad. We understand the inherent challenges of stepping into a new and unfamiliar environment, far from the comfort of home, family, and friends. In recognition of these challenges, we have taken proactive measures to provide comprehensive emotional support to our students.</p><p> We don't just claim to be available; we are there for our students at any hour of the day, no matter the distance or time zone. We've received distress calls from students in the wee hours of the morning, and we would do so countless times more because your safety and well-being are our foremost concerns. We want you to feel secure, not only in your physical environment but also in your emotional state.</p> <p>In today's world, with the omnipresence of social media and an abundance of digital content, it's all too easy to feel overwhelmed and homesick, particularly when adapting  to a new culture and the demands of building an independent life and career in a foreign land. That's where our unwavering commitment to mental health support comes into play. We understand that it's not just about being physically present; it's about feeling mentally secure, too.</p><p>Our dedicated mentors are trained to provide compassionate guidance, ensuring that every student feels heard, understood, and valued. Whether it's advice on adapting to a new culture, coping with the demands of independence, or simply lending a compassionate ear, our mentors are there to support you. We consider our students as more than just participants; they are like family to us, and we treat them as such. Furthermore, in the rare instance that our team identifies a student who may benefit from professional counseling or therapy, we have an extensive network of trusted and certified mental health professionals and mentors. We are readily available to connect students with these resources to ensure they receive the care and support they need, at extra cost.</p> <p>At Destiny Calling, we are dedicated to helping students navigate the unique challenges of studying in a foreign country. Together, we foster a nurturing environment where every student is empowered to succeed, not just professionally but personally. Your well-being is our top priority, and we are committed to providing you with the resources and support necessary to thrive during your time abroad"
    }
]

const FranceInternshipProgram = () => {
    const [currentItem, setCurrentItem] = useState(tabData.find(el=>el.id === 1));
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const handleChangeId = (id) =>{
    setCurrentItem(tabData.find(el=>el.id === id));
  }
  return (
    <Fragment>
      <div className="innerPageWrapper">
        <div className="innerPageBanner-2">
          <img
            src="/images/program/france-internships.jpg"
            alt="about-banner"
            className="img-fluid"
          />
        </div>
        <div className="page-content pt-15 pb-50">
          <section className="inner-program-sec-1">
            <div className="container">
              <h4 className="lang-title">
              The Dynamic Path to an Internship or Work Opportunity in France
              </h4>
              <p>
              Embark on a transformative journey in the heart of culinary excellence with Destiny
Calling's France Program. France, renowned for its gastronomic heritage and thriving
tourism industry, offers unparalleled opportunities for Hotel Management and Culinary
students. This program is designed to rapidly boost your career and transform your life. </p>

<p>As pioneers of internships in France for Indian students, our program provides you with
an Internship or work opportunity in France, based on your skills with various groups like
Relais & Chateau, Best Western, Michelin Star restaurants, and fine dining gastronomic
establishments. A monthly stipend, along with duty meals and accommodation, shall be
encompassed in the package. </p>

<p>By participating in the Program, you will have the opportunity to learn from the best in
the industry, refine your skills, and learn a new language.
              </p>
             
             
       
              <div className='eligibility'>
                                <h4 className='lang-title'>Current Openings by Department</h4>
                                <div className='eligibilityItems'>
                                    <ul>
                                        <li><a href='/'><img src='/images/our-program-icon/PASTRY.png' alt='icon' /><span>PASTRY</span></a></li>
                                        <li><a href='/'><img src='/images/our-program-icon/CULINARY.png' alt='icon' /><span>CULINARY</span></a></li>
                                        <li><a href='/'><img src='/images/our-program-icon/FOOD-AND-BEVERAGE.png' alt='icon' /><span>FOOD & BEVERAGE</span></a></li>
                                        <li><a href='/'><img src='/images/our-program-icon/FRONT-OFFICE.png' alt='icon' /><span>FRONT OFFICE</span></a></li>
                                        <li><a href='/'><img src='/images/our-program-icon/HOUSEKEEPING.png' alt='icon' /><span>HOUSEKEEPING</span></a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="application-btn">
                            <Link to={"/about"} className="primaryButton">
                START MY APPLICATION
              </Link>
                            </div>
                          
            </div>
            
          </section>
          <section className="inner-program-sec-2">
            <div className="container">
              <h4 className="lang-title text-center">
              TESTIMONIALS OF OUR FRANCE INTERNS
              </h4>
              <Carousel responsive={responsive} renderArrowsWhenDisabled={true}>
                <div className="cl-items">
                  <p>
                    With a flawless and quick administrative process, Mauritius
                    is among our most loved programs. Principally appreciated by
                    the tourists for its natural environment and man-made
                    attractions, Mauritius possesses a growing tourism sector
                    and a need for skilled hotel management and culinary
                    graduates. This is your chance to rapidly grow your career
                    and transform your life. Mauritius is known for its multi -
                    ethnic diversity, and our program would provide you with an
                    opportunity to engulf yourself in its rich cultural
                    heritage, by Interning with an esteemed hotel in Mauritius
                    for 6 months,
                  </p>
                  <div className="author-details">
                    <span>Sanjeev Singh</span>
                    <span>King’s Collage Londone Communications</span>
                  </div>
                </div>
                <div className="cl-items">
                  <p>
                    With a flawless and quick administrative process, Mauritius
                    is among our most loved programs. Principally appreciated by
                    the tourists for its natural environment and man-made
                    attractions, Mauritius possesses a growing tourism sector
                    and a need for skilled hotel management and culinary
                    graduates. This is your chance to rapidly grow your career
                    and transform your life. Mauritius is known for its multi -
                    ethnic diversity, and our program would provide you with an
                    opportunity to engulf yourself in its rich cultural
                    heritage, by Interning with an esteemed hotel in Mauritius
                    for 6 months,
                  </p>
                  <div className="author-details">
                    <span>Sanjeev Singh</span>
                    <span>King’s Collage Londone Communications</span>
                  </div>
                </div>
                <div className="cl-items">
                  <p>
                    With a flawless and quick administrative process, Mauritius
                    is among our most loved programs. Principally appreciated by
                    the tourists for its natural environment and man-made
                    attractions, Mauritius possesses a growing tourism sector
                    and a need for skilled hotel management and culinary
                    graduates. This is your chance to rapidly grow your career
                    and transform your life. Mauritius is known for its multi -
                    ethnic diversity, and our program would provide you with an
                    opportunity to engulf yourself in its rich cultural
                    heritage, by Interning with an esteemed hotel in Mauritius
                    for 6 months,
                  </p>
                  <div className="author-details">
                    <span>Sanjeev Singh</span>
                    <span>King’s Collage Londone Communications</span>
                  </div>
                </div>
                <div className="cl-items">
                  <p>
                    With a flawless and quick administrative process, Mauritius
                    is among our most loved programs. Principally appreciated by
                    the tourists for its natural environment and man-made
                    attractions, Mauritius possesses a growing tourism sector
                    and a need for skilled hotel management and culinary
                    graduates. This is your chance to rapidly grow your career
                    and transform your life. Mauritius is known for its multi -
                    ethnic diversity, and our program would provide you with an
                    opportunity to engulf yourself in its rich cultural
                    heritage, by Interning with an esteemed hotel in Mauritius
                    for 6 months,
                  </p>
                  <div className="author-details">
                    <span>Sanjeev Singh</span>
                    <span>King’s Collage Londone Communications</span>
                  </div>
                </div>
              </Carousel>
            </div>
          </section>
          <section className="inner-program-sec-3">
            <div className="container">
              <h4 className="lang-title text-center">
              France Internship Inclusions
              </h4>
              <div className="dxt-box">
              <div className="int-tab">
                <ul className="int-tab-link">
                    {
                        tabData.map((item, i)=>{
                            return <li key={item.id}>
                            <button className={currentItem.id === item.id ? "active" : ""} onClick={()=>handleChangeId(item.id)}>{item.title}</button>
                          </li>
                        })
                    }
                </ul>
                <div className="int-tab-body">
                  <p>
                     {parse(currentItem.desc)}
                  </p>
                </div>
              </div>
              </div>
            
             <div className="mb-box">
                <ProgramAccordions data={tabData}/>
             </div>
             


            </div>
          </section>
          <section className="inner-program-sec-4">
              <div className="container">
                <h4 className="lang-title text-center">
                   Life as an intern in France
                </h4>
                {/* <div className="snapList">
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-1.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-2.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-3.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-4.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-5.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-6.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-7.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-8.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-9.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                     <div className="spanItem">
                     <img
                       src="/images/snapshot/sp-10.png"
                       alt="sp-1"
                       className="img-fluid"
                     />
                     </div>
                </div> */}
                 <ImageGallery images={images}/>
              </div>

             
          </section>
          <section className="inner-program-sec-5">
              <div className="container">
                <div className="row">
                   <div className="col-md-4">
                       <div className="iconBox">
                           <div className="iconBoxImage">
                             <img
                               src="/images/dream.png"
                               alt="sp-1"
                               className="img-fluid"
                             />
                           </div>
                           <div className="iconBoxContent">
                             <h4>Get our brochures and a quote</h4>
                             <Link to={"/"} className="primaryButton ">
                              DOWNLOAD NOW
                            </Link>
                           </div>
                       </div>
                   </div>
                   <div className="col-md-4">
                       <div className="iconBox">
                           <div className="iconBoxImage">
                             <img
                               src="/images/ques.png"
                               alt="sp-1"
                               className="img-fluid"
                             />
                           </div>
                           <div className="iconBoxContent">
                             <h4>Why choose destiny calling?</h4>
                             <Link to={"/why-choose-us"} className="primaryButton">
                              WHY US
                            </Link>
                           </div>
                       </div>
                   </div>
                   <div className="col-md-4">
                       <div className="iconBox">
                           <div className="iconBoxImage">
                             <img
                               src="/images/connect.png"
                               alt="sp-1"
                               className="img-fluid"
                             />
                           </div>
                           <div className="iconBoxContent">
                             <h4>Interact with our expert</h4>
                             <Link to={"/contact-us"} className="primaryButton mt-30">
                               CONTACT US
                            </Link>
                           </div>
                       </div>
                   </div>
                </div>
              </div>
          </section>
        
        </div>
        <section
            className="career-section"
            style={{
              backgroundImage: `url('/images/blogThumb.png')`,
            }}
          >
            <div className="container">
              <div className="career-inner-2">
                <h3>HAVE QUESTIONS? SCROLL THROUGH OUR EFFECTIVE FAQ RESOURCE THAT WILL EDUCATE, INFORM AND ANSWER ALL YOUR QUERIES.</h3>
                <Link to="/faq" className="borderButton">
                  FAQ'S
                </Link>
              </div>
            </div>
            <div className="careerOverlay"></div>
          </section>
      </div>
    </Fragment>
  );
};

export default FranceInternshipProgram;
